import getLogger from '@signal/core/fe-logging'
import {
  DataMiddlewareType,
  ErrorWithResponseType,
  ResponseOrErrorType
} from './types'

// this middleware logs any fetch errors to logging solution
const logAPIThrowsMiddleware = (): DataMiddlewareType => async (
  respOrError?: ResponseOrErrorType
): Promise<ResponseOrErrorType> => {
  if (respOrError instanceof Error) {
    const { response } = respOrError as ErrorWithResponseType
    if (response) {
      let body
      const { url, status } = response
      try {
        body = await response.clone().text()
      } catch (err) {
        if (err instanceof Error) {
          body = 'fetch failure'
        }
      }
      getLogger().error(
        'saw api error: {body}, {error_url}, {status}',
        body,
        url,
        status
      )
    } else {
      const url = (respOrError as ErrorWithResponseType).url ?? ''
      getLogger().error(
        'saw api error: {error}, {error_url}',
        respOrError.message,
        url
      )
    }
  }
  return respOrError
}

export default logAPIThrowsMiddleware
